import clsx from 'clsx';
import { type Maybe } from './maybe';

type OverflowPanelClassName = Maybe<string>;

type OverflowPanelProps = {
    panelClassName?: OverflowPanelClassName;
    shouldUseOverflow: boolean;
    wrapItems?: boolean;
};

type ResolvedOverflowPanelProps = {
    resolvedPanelClassName: string | undefined;
};

export function resolveOverflowPanelProps({
    panelClassName,
    shouldUseOverflow,
    wrapItems,
}: OverflowPanelProps): ResolvedOverflowPanelProps {
    const resolvedPanelClassName = clsx(
        panelClassName,
        shouldUseOverflow && 'ics-overlay-panel--overflow',
        wrapItems && 'ics-multiselect-panel--wrap-items',
    );

    return {
        resolvedPanelClassName: resolvedPanelClassName || undefined,
    };
}
